<template>
    <section class="partners-media-container" :style="style">
        <div class="partners-media content-container">
            <div class="partners-media__container">
                <h1 class="partners-media__title">
                    {{ translations.pageTitle }}
                </h1>

                <h2 class="partners-media__subtitle  u-heading-4">
                    {{ translations.mediaTitle }}
                </h2>

                <div class="partners-media__partners">
                    <div
                        v-for="item in media"
                        class="partners-media__partner"
                    >
                        <WatsonThemePartnerHighlight :content="item" />
                    </div>
                </div>

                <h2 class="partners-media__subtitle u-heading-4">
                    {{ translations.partnerTitle }}
                </h2>

                <div class="partners-media__partners">
                    <div
                        v-for="item in partners"
                        class="partners-media__partner"
                    >
                        <WatsonThemePartnerHighlight :content="item" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import WatsonThemePartnerHighlight from '../../components/partner-highlight/watson-theme-partner-highlight.vue';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps({
    content: {
        type: Array,
        required: true,
    },
    partnersMedia: {
        type: Object,
        required: true,
    },
});

const page = usePage();
const translations = page.props.settings.translations.partnersMedia;

const media = props.partnersMedia.items.filter(partner => partner.type === 'media');
const partners = props.partnersMedia.items.filter(partner => partner.type === 'partner');

const style = computed(() => ({
    '--partner-background': props.partnersMedia.style.background || 'initial',
    '--partner-border-color': props.partnersMedia.style.border || 'initial',
    '--partner-title-color': props.partnersMedia.style.title || 'initial',
    '--partner-date-color': props.partnersMedia.style.date || 'initial',
    '--partner-link-color': props.partnersMedia.style.link || 'initial',
    '--partner-link-hover-color': props.partnersMedia.style.linkHover || 'initial',
}));
</script>

<style lang="scss">
@use 'partners-index';
</style>
